import { render } from "./IconLanguage.vue?vue&type=template&id=fe05022c"
import script from "./IconLanguage.vue?vue&type=script&lang=js"
export * from "./IconLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__